import { Cell } from '@/models/GenericInterfaces'

const getId = (num: number, prefix: string) => `${prefix}-${num}`
export const getRowId = (row: number) => getId(row, 'product')
export const getColumnId = (column: number) => getId(column, 'column')
export const getCellId = (cell: Cell) => `cell-${cell.rowIndex}-${cell.columnIndex}`
